/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
// disable patching requestAnimationFrame
(window as any).__Zone_disable_requestAnimationFrame = true;

// disable patching specified eventNames
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['mousemove', 'mouseover', 'mouseenter','mouseleave', 'mouseout'];